<div class="dashboard fade-in">
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2>Dashboard</h2>
          <p class="text-muted">Panel Administrativo de Operaciones SaaS</p>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-success" (click)="exportToExcel()" [disabled]="loading || !hasData">
            <i data-feather="download"></i>
            <span class="ms-2">Exportar a Excel</span>
          </button>
          <button class="btn btn-outline-primary" (click)="loadMetrics()" [disabled]="loading">
            <i data-feather="refresh-cw"></i>
            <span class="ms-2">Actualizar</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="row">
    <div class="col-12 text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="text-muted mt-3">Cargando métricas...</p>
    </div>
  </div>

  <!-- Métricas -->
  <div *ngIf="!loading" class="row">
    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">MRR Total</h6>
              <h3 class="mb-0">{{ hasData ? formatCurrency(metrics.mrr) : formatCurrency(0) }}</h3>
              <small *ngIf="hasData && metrics.mrrGrowth !== undefined" 
                     [class]="metrics.mrrGrowth >= 0 ? 'text-success' : 'text-danger'">
                <i [attr.data-feather]="metrics.mrrGrowth >= 0 ? 'trending-up' : 'trending-down'"></i>
                {{ metrics.mrrGrowth >= 0 ? '+' : '' }}{{ metrics.mrrGrowth }}% vs período anterior
              </small>
            </div>
            <div class="icon-box bg-primary">
              <i data-feather="dollar-sign"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Clientes Activos</h6>
              <h3 class="mb-0">{{ hasData ? metrics.activeCustomers : '0' }}</h3>
              <small *ngIf="hasData && metrics.customersGrowth !== undefined" 
                     [class]="metrics.customersGrowth >= 0 ? 'text-success' : 'text-danger'">
                <i [attr.data-feather]="metrics.customersGrowth >= 0 ? 'trending-up' : 'trending-down'"></i>
                {{ metrics.customersGrowth >= 0 ? '+' : '' }}{{ metrics.customersGrowth }}% vs período anterior
              </small>
            </div>
            <div class="icon-box bg-success">
              <i data-feather="users"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">ARR Total</h6>
              <h3 class="mb-0">{{ hasData ? formatCurrency(metrics.arr) : formatCurrency(0) }}</h3>
              <small *ngIf="hasData && metrics.arrGrowth !== undefined" 
                     [class]="metrics.arrGrowth >= 0 ? 'text-success' : 'text-danger'">
                <i [attr.data-feather]="metrics.arrGrowth >= 0 ? 'trending-up' : 'trending-down'"></i>
                {{ metrics.arrGrowth >= 0 ? '+' : '' }}{{ metrics.arrGrowth }}% vs período anterior
              </small>
            </div>
            <div class="icon-box bg-warning">
              <i data-feather="bar-chart-2"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Churn Rate</h6>
              <h3 class="mb-0">{{ hasData ? metrics.churnRate.toFixed(1) + '%' : '0%' }}</h3>
            </div>
            <div class="icon-box bg-danger">
              <i data-feather="trending-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Métricas Adicionales -->
  <div *ngIf="!loading && hasData" class="row">
    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Nuevos Clientes</h6>
              <h3 class="mb-0">{{ metrics.newCustomers }}</h3>
              <small class="text-muted">Este período</small>
            </div>
            <div class="icon-box bg-info">
              <i data-feather="user-plus"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Upgrades</h6>
              <h3 class="mb-0">{{ metrics.upgrades }}</h3>
              <small class="text-muted">Mejoras de plan</small>
            </div>
            <div class="icon-box bg-success">
              <i data-feather="arrow-up-circle"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Downgrades</h6>
              <h3 class="mb-0">{{ metrics.downgrades }}</h3>
              <small class="text-muted">Reducciones de plan</small>
            </div>
            <div class="icon-box bg-warning">
              <i data-feather="arrow-down-circle"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h6 class="text-muted mb-2">Cuentas Vencidas</h6>
              <h3 class="mb-0">{{ metrics.overdueAccounts }}</h3>
              <small class="text-muted">Requieren atención</small>
            </div>
            <div class="icon-box bg-danger">
              <i data-feather="alert-circle"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Bienvenido al Panel Administrativo</h5>
        </div>
        <div class="card-body">
          <p>Este es el panel administrativo de operaciones SaaS de Khipure.</p>
          <p>Desde aquí podrás gestionar:</p>
          <ul>
            <li>Métricas y KPIs del negocio SaaS</li>
            <li>Clientes y su salud (Customer Health)</li>
            <li>Suscripciones activas y canceladas</li>
            <li>Solicitudes de activación y upgrades</li>
            <li>Cupones, referidos y comisiones</li>
            <li>Catálogo de productos y planes de precios</li>
          </ul>
          <p class="text-muted mb-0">Utiliza el menú lateral para navegar entre las diferentes secciones.</p>
        </div>
      </div>
    </div>
  </div>
</div>
